export default {
  login_p_phone: "請輸入手機號碼",
  login_p_success_phone: "請輸入正確的手機號碼",
  login_p_phone_toast: "手機號碼格式錯誤",
  login_p_code: "請輸入驗證碼",
  login_code: "輸入驗證碼",
  login_p_success_code: "請輸入正確的驗證碼",
  login_get_code: "取得驗證碼",
  login_again_get_code: "秒後重新取得",
  login_again_send: "重新傳送",
  login_again_send_code: "重發驗證碼",
  login_send_your_mobile_phone: "已傳送至您的 $1 手機",
  login_submit: "登入",
  login_submit_msg: "新使用者登入即同意註冊",
  login_submit_success_toast: "登入成功",
  login_method_change_password: "使用密碼登入",
  login_method_password: "密碼登入",
  login_method_change_code: "使用手機號碼註冊/登入",
  login_p_password: "請輸入密碼",
  login_submit_forget_pass: "忘記密碼？",
  login_l_account: "帳號",
  login_l_register: "註冊",
  login_submit_code: "驗證碼登入",
  login_method_new_users_register: "新使用者點選註冊",
  login_new_users_register_true_login: "新使用者註冊即代表同意登入",
  login_account_password: "已有帳號,使用密碼登入",
  login_reset_nav_title: "重設密碼",
  login_setPwd_nav_title: "設定密碼",
  login_l_phone: "手機號碼",
  login_l_code: "驗證碼",
  login_l_password: "密碼",
  login_l_re_password: "確認密碼",
  login_ok: "確認",
  login_p_re_password: "請確認密碼",
  login_pass_tips: "*密碼由8-20位元任意字元組成",
  login_pass_reset_success: "密碼重設成功",
  login_pass_set_success: "設定成功",
  login_pass_no_format: "密碼過於簡單",
  login_pass_no_same: "密碼不一致",
  login_code_format: "驗證碼錯誤",
  login_jump: "跳過",
  login_title_tips: "提 醒",
  login_btn_cancel: "取消",
  login_content_go_res: "您的手機號碼暫未註冊，是否前往註冊？",
}